export default {
  to: "/admin",
  order: 4,
  icon: "mdi-view-dashboard",
  title: "Administration",
  type: "admin",
  disabled: false,
  sublinks: [
    {
      to: "/admin/students",
      icon: "mdi-account-multiple",
      title: "Students",
      disabled: false,
      value: 0,
    },
    {
      to: "/admin/list",
      icon: "mdi-account-circle",
      title: "Admins",
      disabled: false,
      value: 0,
    },
    {
      to: "/admin/roles",
      icon: "mdi-account-circle",
      title: "Roles",
      disabled: false,
      value: 0,
    },
    {
      to: "/admin/applications",
      icon: "mdi-sort-variant",
      title: "Approved Applications",
      disabled: false,
      value: 0,
    },
    // {
    //   to: "/admin/iblLinks",
    //   icon: "mdi-file-link-outline",
    //   title: "IBL Links",
    //   disabled: false,
    //   value: 0,
    // },
    {
      order: 0,
      title: "Admin Settings",
      icon: "settings",
      to: "/admin/settings",
      type: "admin",
    },
  ],
};
